export default __webpack_public_path__ + "static/media/stays_logo.d2f818f8.svg";